<template>
  <div>
    <a href="#" v-b-modal="modalID">
      <i class="fa fa-plus"></i>
      Add
    </a>

    <b-modal title="Create categories" :id="modalID" :ref="modalID" no-close-on-esc no-close-on-backdrop hide-footer size="md">
      <p><em>Select a top category and enter each item of subject on a separate line e.g:</em></p>
      Subategory one <br />
      Subategory two <br />
      Subategory three <br />
      Etc ...
      <p>&nbsp;</p>
      <form @submit.prevent="createSubCategories">
        <div class="form-group mb-2">
          <select v-model="topCategoryUUID" class="form-control">
            <optgroup v-for="(cat, i) in categories" :key="i">
              <option :value="cat.uuid">{{ cat.name }}</option>
            </optgroup>
          </select>
        </div>
        <div class="form-group mb-2">
          <textarea v-model="subCategoryListString" rows="7" class="form-control" :class="{ 'is-invalid': $v.subCategoryListString.$error, 'is-valid': !$v.subCategoryListString.$invalid }"></textarea>
          <div class="invalid-feedback">
            <span v-if="!$v.subCategoryListString.required">List is required.</span>
          </div>
        </div>
        <button type="submit" class="btn btn-secondary mb-2" :disabled="isDisabled">{{ myButton }}</button>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    clientRef: String,
    categories: {
      type: Array,
    },
  },
  data() {
    return {
      modalID: "subCategories",
      topCategoryUUID: "",
      subCategoryListString: "",
      myButton: "Submit",
      isDisabled: false,
    };
  },
  methods: {
    createSubCategories() {
      this.isDisabled = true;
      this.myButton = "Working... please wait.";

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isDisabled = false;
        return;
      }

      //console.log(this.clientRef);
      //console.log(this.topCategoryUUID);
      //console.log(this.subCategoryListString);

      let formData = new FormData();
      formData.append("ref", this.clientRef);
      formData.append("categoryUUID", this.topCategoryUUID);
      formData.append("subcategories", this.subCategoryListString);
      axios.post(`/team/create/subcategories`, formData).then((res) => {
        //console.log(res.data);
        if (res.data.status === "success") {
          //this.isDisabled = false;
          //this.myButton = "Submit";
          //this.$refs[this.modalID].hide();
          window.location.reload();
        }
      });
    },
  },
  validations: {
    subCategoryListString: { required },
  },
};
</script>

<style>
</style>